import { render, staticRenderFns } from "./PAN.vue?vue&type=template&id=af81ddf8&scoped=true&"
import script from "./PAN.vue?vue&type=script&lang=js&"
export * from "./PAN.vue?vue&type=script&lang=js&"
import style0 from "./PAN.vue?vue&type=style&index=0&id=af81ddf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af81ddf8",
  null
  
)

export default component.exports